import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import * as CONFIG from 'constants/config';
import {
  DropDownChonPhongBanThuocCoQuan,
  DropDownChonCanBoXuLy,
  DropDownChonDonViTTXM,
  DropDownChonQuyTrinhGiaiQuyetDon,
  DropDownChonHuongXuLyTheoDon,
  DropDownChonNhomThamQuyenGiaiQuyet,
  DropDownMulipleUse
} from 'components/tt-forms';
import { processType } from 'constants/process-type';
import { DatePicker, TextArea, DropDownTreeSelectOneElement } from 'components/tt-forms/common';
import { ShowIf } from 'components/utils';
import InPhieu from 'modules/handle-letters/xu-ly-don/form-xu-ly/chuyen-vien/InPhieu.jsx';
import { validatable } from 'components/utils';
import { LetterProcessingWorkFlow, DuLieuHeThong, Reception } from 'api';
import { ContainerFileDinhKem } from 'components/upload';
import { msg } from "constants/message";
import {AutoSuggest} from "modules/auto-complete";
import {ConfirmDialog} from 'modules/dialog';
import { Toastr } from 'modules/toastr';
var Promise = require('es6-promise').Promise;
const loaiTepDinhKem = 'QUYET_DINH';
const loaiQuyTrinh = 'XU_LY_DON';

const process = [processType.xuLyDon.processing.truongPhongGiaoViecChuyenVien, processType.xuLyDon.processing.ketThuc, processType.xuLyDon.processing.deXuatGiaoViecLai];

class TruongPhongGiaoViec extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      form_TruongPhongGiaoViecCanBo: false,
      form_DeXuatGiaoViecLai: false,

      donId: this.props.donId,

      numberState: 0,
      onlyState: '',

      nextState: '',

      hideDropdown: false,
      focused: false,
      lblTextArea: 'Ý kiến xử lý',
      phongBan: this.props.userInfo.coQuanQuanLyId,
      noiDung: '',
      canBoChiDinh: '',
      phongBanXuLyChiDinh: '',
      // can bo

      huongXuLy: '',
      thamQuyenGiaiQuyet: '',
      hanGiaiQuyet: '',

      // huongXuLy: THU_LY
      trangThaiTTXM: '',

      // trangThaiTTXM: GIAO_TTXM
      donViThamTraXacMinh: '',
      donViThamTraXacMinhTen: '',
      thoiHanBaoCaoKetQuaTTXM: '',

      phongBanGiaiQuyet: '',

      truongPhongChiDinh: '',
      coQuanTiepNhanTen: '',
      coQuanTiepNhan: null,
      donViNgoaiHeThong: '',
      donViNgoaiHeThongId: '',

      // Tai lieu
      listTaiLieuVanThu: [],
      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],
      dataShow: [],
      dataNexstate: [],
      dataDonViTTXM: [],
      popupConfirmHXL: false,
      hasFileChange: false,
      prepareData: {},
      ngayRaThongBaoThuLy: '',
      ngayRaThongBaoTTXM: '',
      loaiVanBanSuggest: '',
      ngayQuyetDinhSuggest: '',
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.huongXuLy != prevState.huongXuLy) {

      switch (this.state.huongXuLy) {

        case processType.xuLyDon.huongXuLy.deXuatThuLy:

          this.setState({
            lblTextArea: 'Ý kiến xử lý',
            requireText: false,
          })
          return;
        case processType.xuLyDon.huongXuLy.luuDonVaTheoDoi:

          this.setState({
            lblTextArea: 'Lý do lưu đơn',
            requireText: true,
          })
          return;
        case processType.xuLyDon.huongXuLy.khongXuLyNeuLyDo:
          this.setState({
            lblTextArea: 'Lý do',
            requireText: true,
          })
          return;
        default:
          this.setState({
            lblTextArea: 'Ý kiến xử lý',
            requireText: false,
          })
          return;
      }
    }
    if(prevProps.truongPhongThuHoi == true) {
      if (this.select && prevState.focused == false) {
        this.setState({
          focused: true
        })
        this.select.focus();
      }
    }
  }

  componentWillMount() {
    this.checkState();
  }

  checkState() {

    let numberState = 0;
    let onlyState = '';
    process.map((item, i) => {
      if (this.props.getState(this.props.listNextStates, item)) {

        onlyState = item;
        numberState++;

        switch (item) {

          case processType.xuLyDon.processing.truongPhongGiaoViecChuyenVien:
            this.setState({
              onlyState: onlyState,
              numberState: numberState,
              form_TruongPhongGiaoViecCanBo: true
            })
            break;

          case processType.xuLyDon.processing.deXuatGiaoViecLai:
            this.setState({
              onlyState: onlyState,
              numberState: numberState,
              form_DeXuatGiaoViecLai: true
            })
            break;

          case processType.xuLyDon.processing.ketThuc:
            this.setState({
              onlyState: onlyState,
              numberState: numberState,
              form_DeXuatGiaoViecLai: true
            })
            break;
        }
      }
    });
  }

  componentDidMount() {
    if (this.state.donId != 0) {
      this.getThongTinXuLy(this.state.donId);
    }
    this.getListDocument();
    let getPhongBan = [...this.props.listNextStates].filter(item => item.type === "XLD_GIAO_PHONG_CUNG_CAP")
    if (getPhongBan.length) {
      let phoPhong = {
        stateId: getPhongBan[0].stateId,
        ten: "Trưởng phòng giao việc phó phòng",
        tenVietTat: "Giao việc phó phòng",
        type: "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG"
      }
      this.props.listNextStates.push(phoPhong)
    }
    let dataNexstate = [...this.props.listNextStates];
    let dataNexstateFilter = [];
    dataNexstate.map(item => {
      let newItem = item;
      if (item.type == 'KET_THUC') {
        newItem.tenVietTat = 'Tự xử lý';
        newItem.ten = 'Trưởng phòng tự xử lý';
      }
      dataNexstateFilter[dataNexstateFilter.length] = newItem;
    })
    this.setState({
      dataNexstate: dataNexstateFilter
    })
    this.getDonViTTXM();
  }

  getDonViTTXM() {
    let params={
      loaiDon: this.props.loaiDonGiaTri ? this.props.loaiDonGiaTri : null
    }
    DuLieuHeThong.actions.getDonViTTXMNew.request('',params).then(res => {
      if (res.data._embedded) {
        this.setState({
          dataDonViTTXM: res.data._embedded.coQuanQuanLies
        })
      }
    })
  }

  componentWillReceiveProps(nextProps) {
    let dataNexstate = [...nextProps.listNextStates];
    let dataNexstateFilter = [];
    let getPhongBan = [...dataNexstate].filter(item => item.type === "XLD_GIAO_PHONG_CUNG_CAP" || item.type === "XLD_UBNDTP_GIAO_PHONG_CUNG_CAP");
    let getPhoPhong = [...dataNexstate].filter(item => item.type === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG");
    if (!getPhoPhong.length && getPhongBan.length) {
      let phoPhong = {
        stateId: getPhongBan[0].stateId,
        ten: "Trưởng phòng giao việc phó phòng",
        tenVietTat: "Giao việc phó phòng",
        type: "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG"
      }
      dataNexstate.push(phoPhong)
    }
    dataNexstate.map(item => {
      let newItem = item;
      if (item.type == 'KET_THUC') {
        newItem.tenVietTat = 'Tự xử lý';
        newItem.ten = 'Trưởng phòng tự xử lý';
      }
      dataNexstateFilter[dataNexstateFilter.length] = newItem;
    })
    this.setState({
      dataNexstate: dataNexstateFilter
    });
  }

   // Add component Util
  getListDocument() {

    let dataShow = this.props.listTaiLieuVanThu.filter((item) => {
      return item.donId != this.state.donId
    })

    this.setState({
      dataShow: dataShow
    })
  }

  onlyOneState() {
    if(this.state.nextState) {
      //do nothing
      this.trigger(this.state, true);
    } else if (this.state.numberState == 1) {
      let newState = {
        ...this.state,
        nextState: this.state.onlyState,
        hideDropdown: true,
      }

      this.setState({
        ...newState
      }, this.trigger(newState, true));
    } else {
      let newState={
        ...this.state
      }
      if (this.state.huongXuLy || this.props.truongPhongThuHoi == true) {
        newState = {
          ...this.newState,
          nextState: 'KET_THUC'
        }
      } else {
        newState = {
          ...this.newState,
          // nextState: 'TRUONG_PHONG_GIAO_VIEC_CAN_BO'
        }
      }

      this.setState({
        ...newState
      },()=>{
        this.trigger(this.state, true)
      });
    }
  }

  getThoiHanGQDonMacDinh() {
    let params = {
      type: this.props.loaiDonGiaTri
    }
    if ((this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO' || this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') && this.state.ngayRaThongBaoThuLy) {
      params.ngayRaThongBaoGiaiQuyet = moment(this.state.ngayRaThongBaoThuLy, 'DD/MM/YYYY').add(7, 'hours').toISOString();
    }
    DuLieuHeThong.actions.getThoiHanGQDonMacDinh.request(null, params).then(res => {
      let thoiHanXuLyMacDinh = moment(res.data).format('DD/MM/YYYY');
      this.setState({
        hanGiaiQuyet: thoiHanXuLyMacDinh
      }, () => {
        this.trigger(this.state, false);
      })
    })
  }

  getThoiHanTTXMMacDinh() {
    let params = {
      type: this.props.loaiDonGiaTri
    }
    if ((this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO' || this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') && this.state.ngayRaThongBaoTTXM && this.state.trangThaiTTXM == 'GIAO_TTXM') {
      params.ngayRaThongBaoTTXM = moment(this.state.ngayRaThongBaoTTXM, 'DD/MM/YYYY').add(7, 'hours').toISOString();
    }
    DuLieuHeThong.actions.getThoiHanTTXMMacDinh.request(null, params).then(res => {
      let thoiHanXuLyMacDinh = moment(res.data).format('DD/MM/YYYY');
      this.setState({
        thoiHanBaoCaoKetQuaTTXM: thoiHanXuLyMacDinh
      }, () => {
        this.trigger(this.state, false);
      })
    })
  }

  getThongTinXuLy(donId) {
    LetterProcessingWorkFlow.actions.getThongTinXuLy.request({ id: donId }).then(res => {
      if (res.data) {
        let info = res.data.thongTinXuLyInfo;
        
        let newState = {...this.state};

        if (info.hanGiaiQuyet == null) {
          this.getThoiHanGQDonMacDinh();
        }

        if ( info.thoiHanBaoCaoKetQuaTTXM == null) {
          this.getThoiHanTTXMMacDinh();
        }
        if (info.nextState && info.nextState.type == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO') {
          newState = {
            ...this.state,
            canBoChiDinh: info.canBoXuLyChiDinh ? info.canBoXuLyChiDinh.id : '',
            noiDung: info.yKienXuLy ? info.yKienXuLy : ''
          }
        } else {
          newState = {
            ...this.state,
            noiDung: info.yKienXuLy ? info.yKienXuLy : '',
            phongBanXuLyChiDinh: info.phongBanXuLyChiDinh && info.phongBanXuLyChiDinh.id ? info.phongBanXuLyChiDinh.id : '',
            canBoChiDinh: info.canBoXuLyChiDinh ? info.canBoXuLyChiDinh.id : '',
            huongXuLy: info.huongXuLy ? info.huongXuLy.giaTri : '',
            thamQuyenGiaiQuyet: info.thamQuyenGiaiQuyet? info.thamQuyenGiaiQuyet.id : '',
            phongBanGiaiQuyet: info.phongBanGiaiQuyet ? info.phongBanGiaiQuyet.id : '',
            donViNgoaiHeThong: info.donViNgoaiHeThong ? info.donViNgoaiHeThong.ten: '',
            donViNgoaiHeThongId: info.donViNgoaiHeThong ? info.donViNgoaiHeThong.id : '',
            coQuanTiepNhan: info.coQuanTiepNhan ? info.coQuanTiepNhan.id : '',
            coQuanTiepNhanTen: info.coQuanTiepNhan ? info.coQuanTiepNhan.ten : '',
            truongPhongChiDinh: info.canBoXuLyChiDinh ? info.canBoXuLyChiDinh.id : '',
            nextState: res.data.phoPhongTemp ? "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG" : (info.nextState ? info.nextState.type : ''),
            trangThaiTTXM: ((info.huongXuLy && info.huongXuLy.giaTri == processType.xuLyDon.huongXuLy.deXuatThuLy) && info.mapTrangThaiTTXM) ? info.mapTrangThaiTTXM.enum : '',
            hanGiaiQuyet: ((info.huongXuLy && info.huongXuLy.giaTri == processType.xuLyDon.huongXuLy.deXuatThuLy) && info.hanGiaiQuyet) ? moment(info.hanGiaiQuyet).format('DD/MM/YYYY') : '',
            donViThamTraXacMinh: ((info.huongXuLy && info.huongXuLy.giaTri == processType.xuLyDon.huongXuLy.deXuatThuLy) && info.donViThamTraXacMinh && info.mapTrangThaiTTXM.enum == 'GIAO_TTXM') ? info.donViThamTraXacMinh.id : '',
            donViThamTraXacMinhTen: ((info.huongXuLy && info.huongXuLy.giaTri == processType.xuLyDon.huongXuLy.deXuatThuLy) && info.donViThamTraXacMinh && info.mapTrangThaiTTXM.enum == 'GIAO_TTXM') ? info.donViThamTraXacMinh.ten : '',
            thoiHanBaoCaoKetQuaTTXM: ((info.huongXuLy && info.huongXuLy.giaTri == processType.xuLyDon.huongXuLy.deXuatThuLy) && info.thoiHanBaoCaoKetQuaTTXM && info.mapTrangThaiTTXM.enum == 'GIAO_TTXM') ? moment(info.thoiHanBaoCaoKetQuaTTXM).format('DD/MM/YYYY') : '',
          }
        }
        this.setState({
          ...newState
        }, () => {
          this.onlyOneState();
          this.checkFileHuongXuLy();
        });
      }
    })
  }

  handleChange(name, e) {
    let newState = {
      ...this.state,
      [name]: e.target.value
    }
    let index = (name == 'coQuanTiepNhan') ? 0 : e.nativeEvent.target.selectedIndex;

    if (name === 'huongXuLy') {
      if (e.target.value === 'DE_XUAT_THU_LY') {
        if (this.state.dataDonViTTXM.length == 0) {
          newState = {
            ...newState,
            noiDung: '',
            thamQuyenGiaiQuyet: 1,
            truongPhongChiDinh: '',
            trangThaiTTXM: 'TU_TTXM'
          }
        } else {
          newState = {
            ...newState,
            noiDung: '',
            thamQuyenGiaiQuyet: 1,
            truongPhongChiDinh: '',
            trangThaiTTXM: ''
          }
        }
      } else {
        newState = {
          ...newState,
          noiDung: '',
          thamQuyenGiaiQuyet: '',
          truongPhongChiDinh: '',
          trangThaiTTXM: ''
        }
      }
      if (this.state.hasFileChange) {
        this.state.prepareData = newState;
        this.state.popupConfirmHXL = true;
        this.setState({...this.state});
        return;
      }
    }

    if (name == 'donViThamTraXacMinh') {

      newState = {
        ...newState,
        donViThamTraXacMinhTen: e.nativeEvent.target[index].text
      }
    }

    if (name == 'phongBanGiaiQuyet') {

      newState = {
        ...newState,
        truongPhongChiDinh: '',
        dataTaiLieuVanThuDelete: this.state.dataTaiLieuVanThuDelete,
      }
    }

    if (name == 'coQuanTiepNhan') {
      newState = {
        ...newState,
        coQuanTiepNhanTen: '',
        dataTaiLieuVanThuDelete: this.state.dataTaiLieuVanThuDelete,
      }
      this.props.coQuanTiepNhanList.map((item) => {
        if (item.coQuanQuanLyId == e.target.value) {
          newState.coQuanTiepNhanTen = item.ten;
        }
      });
    }

    if (name == 'nextState' && e.target.value == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO') {
      newState = {
        ...newState,
        noiDung: '',
        thamQuyenGiaiQuyet: '',
        truongPhongChiDinh: '',
        trangThaiTTXM: '',
        huongXuLy: ''
      }
    } else if (name == 'nextState') {
      newState = {
        ...newState,
        canBoChiDinh: '',
        noiDung: ''
      }
    }

    this.setState({
      ...newState
    },()=> {
      if (name == 'huongXuLy' || (name == 'nextState' && this.state.nextState == 'KET_THUC')) {
        this.checkFileHuongXuLy();
      }

      if (name == 'trangThaiTTXM') {
        this.checkFileTTXM()
      }
      this.trigger(newState, false);
    });
  }

  confirmChangeHuongXuLy(next) {
    if (next) {
      this.setState({
        ...this.state.prepareData,
        hasFileChange: false
      }, () => {
        this.checkFileHuongXuLy();
        this.trigger(this.state.prepareData, false);
      });
    } else {
      this.state.popupConfirmHXL = false;
      this.setState({...this.state});
    }
  }

  compareDate(firstDate, secondDate, type) {
    var firstTime = firstDate.getTime();
    var secondTime = secondDate.getTime()

    if (firstTime > secondTime || type == 'show') {
      return true
    } else {
      return false
    }
  }

  checkFileHuongXuLy() {
    this.setState({
      renderContainer: false
    },()=>{
      let DataInit = [...this.props.listTaiLieuVanThu];
      let dataFileDinhKem = [];
      let dataShow = [];
      if (this.props.ngayTraTTXMKhongDungThamQuyen) {
        dataFileDinhKem = DataInit.filter(state => {
          return this.compareDate(new Date(state.ngayTao), new Date(this.props.ngayTraTTXMKhongDungThamQuyen), 'action');
        })
        dataShow = DataInit.filter(state => {
          return this.compareDate(new Date(this.props.ngayTraTTXMKhongDungThamQuyen), new Date(state.ngayTao), 'show');
        })
        this.setState({
          dataShow: [...dataShow]
        })
      } else if (this.props.ngayNhanDon) {
        dataFileDinhKem = DataInit.filter(state => {
          return this.compareDate(new Date(state.ngayTao), new Date(this.props.ngayNhanDon), 'action');
        })
        dataShow = DataInit.filter(state => {
          return this.compareDate(new Date(this.props.ngayNhanDon), new Date(state.ngayTao), 'show');
        })
        this.setState({
          dataShow: [...dataShow]
        })
      } else {
        dataFileDinhKem = DataInit.filter((item) => {
          return item.donId == this.state.donId
        });
      }
      let typeRequired = '';
      let name = ''
      if (this.state.huongXuLy == 'DE_XUAT_THU_LY') {

        let data = [...dataFileDinhKem];

        let dataExist = data.filter(item => {
          return item.typeRequired == 'XLD_PDXTL'
        });
        if (dataExist.length > 0) {
          let listTaiLieuVanThu = [
            ...dataFileDinhKem
          ];
          let dataFilter = listTaiLieuVanThu.filter(item => {
            return ((item.newFile || !item.newFile) && item.typeRequired == 'XLD_PDXTL') || (!item.newFile && !item.typeRequired)
          })
          this.setState({
            listTaiLieuVanThu: dataFilter,
            ngayRaThongBaoThuLy: dataExist[0].ngayQuyetDinh ? new Date(dataExist[0].ngayQuyetDinh) : ''
          },()=> {
            this.trigger(this.state, false);
            this.setState({
              renderContainer: true
            },()=> {
              this.checkFileTTXM();
            })
          })
        } else if (this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO'){
          let ItemDTTL = {
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            tenFile: '',
            duongDan: '',
            progress: 0,
            required: true,
            typeRequired: 'XLD_PDXTL',
            newFile: true
          }
          if (this.props.loaiDonGiaTri == 'DON_TO_CAO') {
            ItemDTTL.ten = 'Thông báo về việc thụ lý giải quyết tố cáo';
          } else if (this.props.loaiDonGiaTri == 'DON_KHIEU_NAI') {
            ItemDTTL.ten = 'Thông báo về việc thụ lý giải quyết khiếu nại';
          }
          let listTaiLieuVanThu = [
            ...dataFileDinhKem,
            ItemDTTL
          ];
          let dataFilter = listTaiLieuVanThu.filter(item => {
            return ((item.newFile || !item.newFile) && item.typeRequired == 'XLD_PDXTL') || (!item.newFile && !item.typeRequired)
          })

          this.setState({
            listTaiLieuVanThu: dataFilter
          }, () => {
            this.setState({
              renderContainer: true
            },()=> {
              this.checkFileTTXM();
            })
          })
        } else {
          let ItemTL = {
            ten: 'Phiếu đề xuất thụ lý',
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            tenFile: '',
            duongDan: '',
            progress: 0,
            checkValid: true,
            required: false,
            typeRequired: 'XLD_PDXTL',
            newFile: true
          }
          let listTaiLieuVanThu = [
            ...dataFileDinhKem,
            ItemTL
          ];
          let dataFilter = listTaiLieuVanThu.filter(item => {
            return ((item.newFile || !item.newFile) && item.typeRequired == 'XLD_PDXTL') || (!item.newFile && !item.typeRequired)
          })

          this.setState({
            listTaiLieuVanThu: dataFilter
          }, () => {
            this.setState({
              renderContainer: true
            },()=> {
              this.checkFileTTXM();
            })
          })
        }
      } else if (
        (this.state.huongXuLy == 'KHONG_DU_DIEU_KIEN_THU_LY' && (this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO'))
        || (this.state.huongXuLy == 'KHONG_XU_LY_NEU_LY_DO' && this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH')
        || (this.state.huongXuLy == 'CHUYEN_DON' && (this.props.loaiDonGiaTri == 'DON_TO_CAO' || this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH'))
        || (this.state.huongXuLy == 'TRA_DON_VA_HUONG_DAN' && (this.props.loaiDonGiaTri == 'DON_TO_CAO' || this.props.loaiDonGiaTri == 'DON_KHIEU_NAI'))
        || (this.state.huongXuLy == 'HUONG_DAN_VIET_LAI_DON' && this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH')
        || (this.state.huongXuLy == 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN' && (this.props.loaiDonGiaTri == 'DON_TO_CAO' || this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH'))
        || (this.state.huongXuLy == 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN_LUU_DON' && this.props.loaiDonGiaTri == 'DON_KHIEU_NAI')
        ){
        if (this.state.huongXuLy == 'KHONG_DU_DIEU_KIEN_THU_LY' || this.state.huongXuLy == 'KHONG_XU_LY_NEU_LY_DO') {
          typeRequired = 'XLD_KDDKTL';
          if (this.props.loaiDonGiaTri == 'DON_TO_CAO') {
            name = 'Thông báo về việc không thụ lý giải quyết tố cáo'
          } else if (this.props.loaiDonGiaTri == 'DON_KHIEU_NAI') {
            name = 'Thông báo về việc khiếu nại không đủ điều kiện thụ lý giải quyết '
          } else if (this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH'){
            name = 'Thông báo về việc không xử lý giải quyết kiến nghị, phản ánh'
          }
        } else if (this.state.huongXuLy == 'CHUYEN_DON') {
          typeRequired = 'XLD_PCD';
          if (this.props.loaiDonGiaTri == 'DON_TO_CAO') {
            name = 'Văn bản về việc chuyển đơn tố cáo'
          } else if (this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH'){
            name = 'Văn bản về việc chuyển đơn kiến nghị, phản ánh'
          }
        } else if (this.state.huongXuLy == 'TRA_DON_VA_HUONG_DAN') {
          typeRequired = 'XLD_TDHD';
          if (this.props.loaiDonGiaTri == 'DON_TO_CAO') {
            name = 'Văn bản về việc hướng dẫn người tố cáo'
          } else if (this.props.loaiDonGiaTri == 'DON_KHIEU_NAI') {
            name = 'Văn bản về việc hướng dẫn người khiếu nại'
          }
        } else if (this.state.huongXuLy == 'HUONG_DAN_VIET_LAI_DON') {
          typeRequired = 'XLD_TDHD';
          if (this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') {
            name = 'Hướng dẫn đơn có nhiều nội dung khác nhau thuộc nhiều cơ quan có thẩm quyền giải quyết'
          }
        } else if (this.state.huongXuLy == 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN') {
          typeRequired = 'XLD_TDKDTQ';
          name = 'Văn bản về việc trả lại đơn chuyển không đúng thẩm quyền';
        } else if (this.state.huongXuLy == 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN_LUU_DON') {
          typeRequired = 'XLD_TDKDTQLD';
          name = 'Văn bản trả lại đơn chuyển không đúng thẩm quyền';
        }

        let data = [...dataFileDinhKem];
        let dataExist = data.filter(item => {
          return item.required && item.typeRequired == typeRequired
        });

        if (dataExist.length > 0 && this.state.huongXuLy !== 'CHUYEN_DON') {
          let listTaiLieuVanThu = [
            ...dataFileDinhKem
          ];
          let dataFilter = listTaiLieuVanThu.filter(item => {
            return ((item.newFile || !item.newFile) && item.typeRequired == typeRequired) || (!item.newFile && !item.typeRequired)
          })
          this.setState({
            listTaiLieuVanThu: dataFilter
          },()=> {
            this.setState({
              renderContainer: true
            },()=> {
              this.checkFileTTXM();
            })
          })
        } else {
          let newItem = {
            ten: name,
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            tenFile: '',
            duongDan: '',
            progress: 0,
            required: true,
            typeRequired: typeRequired,
            newFile: true
          }

          let listTaiLieuVanThu = [
            ...dataFileDinhKem,
            newItem
          ];
          let dataFilter = [];
          if (this.state.huongXuLy === 'CHUYEN_DON') {
            dataFilter = [
              newItem
            ];
          } else {
            dataFilter = listTaiLieuVanThu.filter(item => {
              return ((item.newFile || !item.newFile) && item.typeRequired == typeRequired) || (!item.newFile && !item.typeRequired)
            })
          }
          this.setState({
            listTaiLieuVanThu: dataFilter
          }, () => {
            this.setState({
              renderContainer: true
            })
          })
        }
      } else {

        let listTaiLieuVanThu = [
          ...dataFileDinhKem
        ];
        let dataFilter = listTaiLieuVanThu.filter(item => {
          return !item.newFile && (item.typeRequired == '' || item.typeRequired == null)
        })
        this.setState({
          listTaiLieuVanThu: dataFilter
        }, () => {
          this.setState({
            renderContainer: true
          })
        })
      }
    })

  }

  checkFileTTXM() {
    this.setState({
      renderContainer: false
    },()=> {

      let dataFileDinhKem = [];
      let DataInit = [...this.props.listTaiLieuVanThu];

      if (this.props.ngayTraTTXMKhongDungThamQuyen) {
        dataFileDinhKem = DataInit.filter(state => {
          return this.compareDate(new Date(state.ngayTao), new Date(this.props.ngayTraTTXMKhongDungThamQuyen), 'action');
        })
      } else {
        dataFileDinhKem = DataInit.filter(item => {
          return item.donId == this.state.donId
        });
      }

      if (this.state.trangThaiTTXM == 'GIAO_TTXM' && (this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO' || this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH')) {
        let data = [...dataFileDinhKem];
        let dataExist = data.filter(item => {
          return item.required && item.typeRequired == 'XLD_GTTXM'
        });

        if (dataExist.length > 0) {
          let listTaiLieuVanThu = [
            ...dataFileDinhKem
          ];
          let dataFilter = listTaiLieuVanThu.filter(item => {
            return (item.newFile && item.typeRequired == 'XLD_PDXTL') || (!item.newFile && item.typeRequired == 'XLD_PDXTL') || (!item.newFile && !item.typeRequired) || (!item.newFile && item.typeRequired == 'XLD_GTTXM')
          })
          this.setState({
            listTaiLieuVanThu: dataFilter,
            ngayRaThongBaoTTXM: dataExist[0].ngayQuyetDinh ? new Date(dataExist[0].ngayQuyetDinh) : ''
          },()=> {
            this.trigger(this.state, false);
            this.setState({
              renderContainer: true
            })
          })
        } else {
          let newItem = {
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            tenFile: '',
            duongDan: '',
            progress: 0,
            required: true,
            typeRequired: 'XLD_GTTXM',
            newFile: true
          }
          if (this.props.loaiDonGiaTri == 'DON_TO_CAO') {
            newItem.ten = 'Quyết định về việc thụ lý giải quyết tố cáo và giao nhiệm vụ xác minh nội dung tố cáo'
          } else if (this.props.loaiDonGiaTri == 'DON_KHIEU_NAI') {
            newItem.ten = 'Quyết định về việc giao nhiệm vụ xác minh nội dung khiếu nại'
          } else if (this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') {
            newItem.ten = 'Văn bản về việc giao nhiệm vụ xác minh nội dung kiến nghị, phản ánh'
          }
          let listTaiLieuVanThu = [
            ...this.state.listTaiLieuVanThu,
            newItem
          ];
          let newPDXItem = this.state.dataFileDinhKem.filter(item => {
            return item.typeRequired == 'XLD_PDXTL'
          });
          if (newPDXItem.length) {
            listTaiLieuVanThu = listTaiLieuVanThu.map(item => {
              return (item.typeRequired == 'XLD_PDXTL') ? newPDXItem[0] : item;
            });
          }
          this.setState({
            listTaiLieuVanThu: listTaiLieuVanThu
          }, () => {
            this.setState({
              renderContainer: true
            })
          })
        }
      } else {
        let listTaiLieuVanThu = [
          ...this.state.listTaiLieuVanThu
        ];
        let dataFilter = listTaiLieuVanThu.filter(item => {
          return item.typeRequired != 'XLD_GTTXM'
        })
        this.setState({
          listTaiLieuVanThu: dataFilter
        }, () => {
          this.setState({
            renderContainer: true
          })
        })
      }
    })

  }

  handleChangeDate(name, e) {
    let newState = {
      ...this.state,
      [name]: e
    }
    if (typeof e.format == 'function') {
      newState = {
        ...this.state,
        [name]: e.format(CONFIG.DateFormat)
      }
    }

    this.setState({
      ...newState
    }, () => {
      if (name == 'ngayRaThongBaoThuLy') {
        let newFileArr = [...this.state.listTaiLieuVanThu];
        newFileArr = newFileArr.map(item => {
          if (item.typeRequired == 'XLD_PDXTL') {
            return item = {
              ...item,
              ngayQuyetDinh: this.state.ngayRaThongBaoThuLy
            };
          }
          return item;
        });
        this.setState({
          loaiVanBanSuggest: 'XLD_PDXTL',
          ngayQuyetDinhSuggest: this.state.ngayRaThongBaoThuLy,
          // listTaiLieuVanThu: newFileArr
        });
        this.getThoiHanGQDonMacDinh();
      }
      if (name == 'ngayRaThongBaoTTXM') {
        this.setState({
          loaiVanBanSuggest: 'XLD_GTTXM',
          ngayQuyetDinhSuggest: this.state.ngayRaThongBaoTTXM
        });
        
        this.getThoiHanTTXMMacDinh();
      }
      if (name == 'hanGiaiQuyet') {
        this.checkHanGiaiQuyet();
      }
      this.trigger(newState, false);
    });
  }

  checkHanGiaiQuyet() {
    let params = {
      loaiDon: this.props.loaiDonGiaTri
    }
    if ((this.props.loaiDonGiaTri == 'DON_TO_CAO' || this.props.loaiDonGiaTri == 'DON_KHIEU_NAI') && this.state.ngayRaThongBaoThuLy) {
      params.ngayBatDau = moment(this.state.ngayRaThongBaoThuLy, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      if (this.state.hanGiaiQuyet) {
        params.ngayKetThuc = moment(this.state.hanGiaiQuyet, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
    }
    DuLieuHeThong.actions.checkHanGiaiQuyet.request(null, params).then().catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail,'error');
      }
    })
  }

  trigger(newState, isInit) {
    let params = {
      yKienXuLy: newState.noiDung,
    };
    if (newState.nextState == "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG") {
      params.phoPhong = true;
      params.phoPhongTemp = true;
      params.phongBanXuLyChiDinh = {
        id: Number(this.state.phongBan)
      };
      if (this.state.canBoChiDinh) {
        params.canBoXuLyChiDinh = {
          id: Number(this.state.canBoChiDinh)
        };
      }
      params.noiDungYeuCauXuLy = this.state.noiDung;
    }

    if (newState.nextState === "XLD_GIAO_PHONG_CUNG_CAP") {
      if (this.state.phongBanXuLyChiDinh) {
        params.phongBanXuLyChiDinh = {
          id: this.state.phongBanXuLyChiDinh
        };
      }
      params.noiDungYeuCauXuLy = this.state.noiDung;
      params.notice = msg.xldTruongPhongGiaoViec;
    }
    if (newState.nextState === "XLD_UBNDTP_GIAO_PHONG_CUNG_CAP") {
      params.phongBanXuLyChiDinh = {
        id: this.state.phongBanXuLyChiDinh
      };
      params.noiDungYeuCauXuLy = this.state.noiDung;
      params.notice = msg.xldTruongPhongGiaoViec;
    }

    if (newState.nextState) {
      let selectState = newState.dataNexstate.find(state => state.type === newState.nextState);
      // let stateId = this.props.getState(this.props.listNextStates, newState.nextState);
      let thamQuyenHanhChinhId = localStorage.getItem('thamQuyenHanhChinhId') || 0;
      if (selectState && selectState.stateId) {
        params.nextState = {
          id: Number(selectState.stateId)
        };
      }
      if (newState.form_TruongPhongGiaoViecCanBo && newState.nextState == processType.xuLyDon.processing.truongPhongGiaoViecChuyenVien) {
        params.notice =  msg.xldTruongPhongGiaoViec;

        if (newState.canBoChiDinh) {
          params.canBoXuLyChiDinh = {
            id: Number(newState.canBoChiDinh)
          }
        }
      } else if (newState.form_TruongPhongGiaoViecCanBo && newState.nextState == processType.xuLyDon.processing.ketThuc) {
        params.huongXuLy = newState.huongXuLy || null;

        if (newState.thamQuyenGiaiQuyet &&
          newState.huongXuLy != processType.xuLyDon.huongXuLy.yeuCauGapLanhDao &&
          newState.huongXuLy != processType.xuLyDon.huongXuLy.luuDonVaTheoDoi)

          params.thamQuyenGiaiQuyet = {
            id: Number(newState.thamQuyenGiaiQuyet)
          }

        if (newState.huongXuLy == processType.xuLyDon.huongXuLy.deXuatThuLy) {

          params.notice = msg.xldChuyenGiaiQuyetDon;
          params.hanGiaiQuyet = moment(newState.hanGiaiQuyet, 'DD/MM/YYYY').add(7, 'hours');
          params.trangThaiTTXM = newState.trangThaiTTXM || null;

          if ((this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO' || this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') && newState.ngayRaThongBaoThuLy) {
            params.ngayRaThongBaoThuLy = moment(newState.ngayRaThongBaoThuLy, 'DD/MM/YYYY').add(7, 'hours').toISOString();
          }

          if (newState.trangThaiTTXM == "TU_TTXM") {

            if (newState.phongBanGiaiQuyet)
              params.phongBanGiaiQuyet = { id: Number(newState.phongBanGiaiQuyet) };

            if (newState.truongPhongChiDinh)
              params.canBoXuLyChiDinh = { id: Number(newState.truongPhongChiDinh) };

          } else if (newState.trangThaiTTXM == "GIAO_TTXM") {
            if (newState.donViThamTraXacMinh) {
              params.donViThamTraXacMinh = { id: Number(newState.donViThamTraXacMinh) };
              params.donViThamTraXacMinhTen = newState.donViThamTraXacMinhTen;
            }

            if (newState.thoiHanBaoCaoKetQuaTTXM) {
              params.thoiHanBaoCaoKetQuaTTXM = moment(newState.thoiHanBaoCaoKetQuaTTXM, 'DD/MM/YYYY').add(7, 'hours').toISOString();
            }

            if ((this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO' || this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') && newState.ngayRaThongBaoTTXM) {
              params.ngayRaThongBaoTTXM = moment(newState.ngayRaThongBaoTTXM, 'DD/MM/YYYY').add(7, 'hours').toISOString();
            }
          }
        } else if (newState.huongXuLy == processType.xuLyDon.huongXuLy.chuyenDon) {
          if (newState.thamQuyenGiaiQuyet == thamQuyenHanhChinhId) {
            params.notice = msg.xldChuyenDon;
            params.coQuanTiepNhan = {
              id: Number(newState.coQuanTiepNhan),
              ten: newState.coQuanTiepNhanTen
            };
          } else {
            params.notice = msg.xldLuuHoSo;
            params.donViNgoaiHeThong = newState.donViNgoaiHeThong;
            params.donViNgoaiHeThongId = newState.donViNgoaiHeThongId;
          }
        } else if (newState.huongXuLy == processType.xuLyDon.huongXuLy.yeuCauGapLanhDao) {
          params.notice = msg.xldYeuCauGapLanhDao;
        } else if (newState.huongXuLy == processType.xuLyDon.huongXuLy.traDonChuyenKhongDungThamQuyen) {
          params.notice = msg.xldTraDon;
        } else if (newState.huongXuLy != processType.xuLyDon.huongXuLy.deXuatThuLy &&
          newState.huongXuLy != processType.xuLyDon.huongXuLy.chuyenDon &&
          newState.huongXuLy != processType.xuLyDon.huongXuLy.yeuCauGapLanhDao) {

          params.notice = msg.xldLuuHoSo;
        }
      } else if (newState.form_TruongPhongGiaoViecCanBo && newState.nextState == processType.xuLyDon.processing.deXuatGiaoViecLai) {
        params.notice = msg.xldTruongPhongGiaoViec;
      } else if (newState.form_TruongPhongGiaoViecCanBo && newState.nextState == processType.xuLyDon.processing.truongPhongGiaoViecPhoPhong) {
        params.notice = msg.xldTruongPhongGiaoViec;

      }
    } else {
      params.nextState = null;
    }
    this.props.onChange(params, isInit);
  }

  onFileRemove(id, data) {

    let temp = {
      dataFileDinhKem: data,
      dataTaiLieuVanThuDelete: [
        ...this.state.dataTaiLieuVanThuDelete,
        id
      ]
    }

    this.setState({
      ...temp
    });



    this.props.onChangeTepDinhKem(temp.dataFileDinhKem, temp.dataTaiLieuVanThuDelete, loaiQuyTrinh, loaiTepDinhKem);
  }

  onFileChange(data) {
    let oldData = [...this.state.dataFileDinhKem];
    let tbtlDate = data.filter(item => {
      return item.typeRequired == 'XLD_PDXTL';
    });
    let tbtlOldDate = oldData.filter(item => {
      return item.typeRequired == 'XLD_PDXTL';
    });
    let tbTTXMDate = data.filter(item => {
      return item.typeRequired == 'XLD_GTTXM';
    });
    let tbTTXMOldDate = oldData.filter(item => {
      return item.typeRequired == 'XLD_GTTXM';
    });
    if (tbTTXMDate.length > 0) {
      if ((tbTTXMOldDate.length > 0 &&  moment(tbTTXMOldDate[0].ngayQuyetDinh).isSame(tbTTXMDate[0].ngayQuyetDinh) == false) ||
          tbTTXMOldDate.length == 0)
      {
        this.state.ngayRaThongBaoTTXM = tbTTXMDate[0].ngayQuyetDinh;
        this.getThoiHanTTXMMacDinh();
        if (this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH' && this.state.ngayRaThongBaoTTXM) {
          this.state.ngayRaThongBaoThuLy = tbTTXMDate[0].ngayQuyetDinh;
          this.getThoiHanGQDonMacDinh();
        }
      }
    }
    if (tbtlDate.length > 0 && this.props.loaiDonGiaTri != 'DON_KIEN_NGHI_PHAN_ANH') {
      if ((tbtlOldDate.length > 0 && moment(tbtlOldDate[0].ngayQuyetDinh).isSame(tbtlDate[0].ngayQuyetDinh) == false) || tbtlOldDate.length == 0) {
        this.state.ngayRaThongBaoThuLy = tbtlDate[0].ngayQuyetDinh;
        this.getThoiHanGQDonMacDinh();
      }
    }

    this.setState({
      dataFileDinhKem: data
    });

    this.props.onChangeTepDinhKem(data, this.state.dataTaiLieuVanThuDelete, loaiQuyTrinh, loaiTepDinhKem);
  }

  searchDonVi(tuKhoa){
    let inputParams = {
      size: 5,
      page: 0
    }

    inputParams.ten = tuKhoa;

    return Reception.actions.getDonViNgoaiHeThong.request('', inputParams).then(res => {
      if (res.data && res.data._embedded) {
        return Promise.resolve({
          result: res.data._embedded.donViNgoaiHeThongs,
          page: res.data.page
        })
      } else {
        return Promise.resolve(null);
      }
    }).catch(err => {
      return Promise.reject(err);
    });
  }

  onChangeSuggest(name, value) {
    this.state[name] = value;
    this.state.donViNgoaiHeThongId = '';
    this.setState({...this.state});
    this.trigger(this.state, false);
  }

  onSelectedSuggest(item) {
    this.state.donViNgoaiHeThong = item.ten;
    this.state.donViNgoaiHeThongId = item.donViNgoaiHeThongId;
    this.setState({...this.state});
    this.trigger(this.state, false);
  }

  render() {
    let thamQuyenHanhChinhId = localStorage.getItem('thamQuyenHanhChinhId') || 0;
    let lb1 = this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
    return (
      <div className="items-form mb0-18">
        <ConfirmDialog title={msg.confirmChange} open={this.state.popupConfirmHXL} onClose={this.confirmChangeHuongXuLy.bind(this, false)} onSuccess={this.confirmChangeHuongXuLy.bind(this, true)}/>
        <div className="row pr10 pl10">
          <ShowIf condition={this.props.listNextStates.length > 1}>
            <DropDownMulipleUse
              className="col-20"
              onRef={select => (this.select = select)}
              require
              data={this.state.dataNexstate}
              bindValidator={this}
              selectedValue={this.state.nextState}
              label="Giao xử lý"
              keyName='type'
              name="huongXuLy"
              valueName='tenVietTat'
              onChange={this.handleChange.bind(this, 'nextState')}/>
          </ShowIf>

          <ShowIf condition={this.state.nextState === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG"}>
            <DropDownChonCanBoXuLy require
              label="Chọn phó phòng"
              bindValidator={this}
              isValid={this.props.validate}
              selectedValue={this.state.canBoChiDinh}
              phongBanId={this.state.phongBan}
              vaiTro="PHO_PHONG"
              onChange={this.handleChange.bind(this, 'canBoChiDinh')}
              name="dropdownTruongPhongChonCanBoXuLy" />
          </ShowIf>
          
          <ShowIf condition={this.state.nextState === "XLD_UBNDTP_GIAO_PHONG_CUNG_CAP"}>
            <DropDownChonPhongBanThuocCoQuan
              require
              bindValidator={this}
              selectedValue={this.state.phongBanXuLyChiDinh}
              isValid={this.props.validate}
              onChange={this.handleChange.bind(this, 'phongBanXuLyChiDinh')}
              name="dropdownChonPhongBanThuocCoQuan" />
          </ShowIf>
          <ShowIf condition={this.state.nextState === "XLD_GIAO_PHONG_CUNG_CAP"}>
            <DropDownChonPhongBanThuocCoQuan
              require
              bindValidator={this}
              selectedValue={this.state.phongBanXuLyChiDinh}
              isValid={this.props.validate}
              onChange={this.handleChange.bind(this, 'phongBanXuLyChiDinh')}
              name="dropdownChonPhongBanThuocCoQuan" />
            {/* <ShowIf condition={this.state.phongBanXuLyChiDinh !== '' }>
              <DropDownChonCanBoXuLy
                bindValidator={this}
                isValid={this.props.validate}
                selectedValue={this.state.canBoChiDinh}
                phongBanId={this.state.phongBanXuLyChiDinh}
                vaiTro="TRUONG_PHONG"
                label="Lãnh đạo phòng"
                onChange={this.handleChange.bind(this, 'canBoChiDinh')}
                name="dropdownTruongPhongChonCanBoXuLy" />
            </ShowIf> */}
          </ShowIf>

          <ShowIf condition={this.state.nextState === "TRUONG_PHONG_GIAO_VIEC_CAN_BO"}>
            <ShowIf condition={this.state.form_TruongPhongGiaoViecCanBo && this.state.nextState == processType.xuLyDon.processing.truongPhongGiaoViecChuyenVien}>
              <DropDownChonCanBoXuLy require
                bindValidator={this}
                isValid={this.props.validate}
                selectedValue={this.state.canBoChiDinh}
                phongBanId={this.state.phongBan}
                vaiTro="CHUYEN_VIEN"
                onChange={this.handleChange.bind(this, 'canBoChiDinh')}
                name="dropdownTruongPhongChonCanBoXuLy" />
            </ShowIf>
          </ShowIf>

          <ShowIf condition={this.state.nextState !== "KET_THUC"}>
            <TextArea
              label="Ý kiến xử lý"
              rows="3"
              className="col-100 mb0-18"
              value={this.state.noiDung}
              onChange={this.handleChange.bind(this, 'noiDung')}
              name="textareaYKienTruongPhong" />
          </ShowIf>
        </div>

        <ShowIf condition={this.state.nextState == 'KET_THUC'}>
          <div className="row pr15 pl10 mt10">
            <DropDownChonHuongXuLyTheoDon require
              selectedValue={this.state.huongXuLy}
              donId={this.props.donId}
              loaiDon={this.props.loaiDonGiaTri}
              label="Giao xử lý"
              onChange={this.handleChange.bind(this, 'huongXuLy')}
              className="col-3"
              bindValidator={this}
              name="dropdownChonHuongXuLyTheoDon" />
            <ShowIf condition={this.state.huongXuLy !== 'YEU_CAU_GAP_LANH_DAO' && this.state.huongXuLy !== 'LUU_DON_VA_THEO_DOI' && this.state.huongXuLy !== 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN_LUU_DON'}>
              <DropDownChonNhomThamQuyenGiaiQuyet require
                filterThamQuyenGiaiQuyet={this.state.huongXuLy === 'CHUYEN_DON'}
                selectedValue={this.state.thamQuyenGiaiQuyet}
                label="Nhóm thẩm quyền giải quyết"
                className="col-3"
                onChange={this.handleChange.bind(this, 'thamQuyenGiaiQuyet')}
                bindValidator={this}
                name="dropdownChonNhomThamQuyenGiaiQuyet" />
            </ShowIf>
            <ShowIf condition={this.state.huongXuLy == processType.xuLyDon.huongXuLy.deXuatThuLy}>
              <ShowIf condition={this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO'}>
                <DatePicker require
                  className="col-25"
                  value={this.state.ngayRaThongBaoThuLy}
                  label='Ngày ra thông báo thụ lý'
                  name="ngayRaThongBaoThuLy"
                  endDate={new Date()}
                  onChange={this.handleChangeDate.bind(this, 'ngayRaThongBaoThuLy')}
                  bindValidator={this}
                  channel="formTaoDon" />
              </ShowIf>
              <DatePicker require
                className="col-25"
                value={this.state.hanGiaiQuyet}
                label='Hạn giải quyết'
                name="hanGiaiQuyet"
                startDate={moment(new Date()).subtract(1, "days")}
                onChange={this.handleChangeDate.bind(this, 'hanGiaiQuyet')}
                bindValidator={this}
                channel="formTaoDon" />
            </ShowIf>
            <ShowIf condition={this.state.huongXuLy == 'CHUYEN_DON' &&  this.state.thamQuyenGiaiQuyet == thamQuyenHanhChinhId}>
              <DropDownTreeSelectOneElement label="Cơ quan tiếp nhận" className='tree-selected' placeholder dataOptions={this.props.coQuanTiepNhanList} value={this.state.coQuanTiepNhan} onChange={this.handleChange.bind(this, 'coQuanTiepNhan')} propertyChildren='coQuanQuanLyCha' propertyParent='coQuanQuanLyId' name="dropdownChonCoQuanTiepNhan" bindValidator={this} channel="formTaoDon" require />
            </ShowIf>
            {
              this.state.thamQuyenGiaiQuyet && this.state.thamQuyenGiaiQuyet != thamQuyenHanhChinhId && this.state.huongXuLy == 'CHUYEN_DON' ?
                <AutoSuggest
                  label="Đơn vị"
                  className="col-3"
                  placeholder="Nhập..."
                  onSearch={this.searchDonVi}
                  onChange={this.onChangeSuggest.bind(this, 'donViNgoaiHeThong')}
                  onSelected={this.onSelectedSuggest.bind(this)}
                  value={this.state.donViNgoaiHeThong}
                  maxLength={40}
                />
              : ''
            }

          </div>
          <ShowIf condition={this.state.huongXuLy == processType.xuLyDon.huongXuLy.deXuatThuLy && this.state.dataDonViTTXM.length > 0}>
            <div className="row pr15 pl10">
              <DropDownChonQuyTrinhGiaiQuyetDon
                className="col-25"
                donId={this.props.donId}
                bindValidator={this}
                require
                loaiDon={this.props.loaiDonGiaTri}
                isValid={this.props.validate}
                selectedValue={this.state.trangThaiTTXM}
                onChange={this.handleChange.bind(this, 'trangThaiTTXM')}
                name="dropdownChonTrangThaiTTXM" />
              <ShowIf condition={this.state.trangThaiTTXM == 'GIAO_TTXM'}>
                <DropDownChonDonViTTXM
                  className="col-25"
                  bindValidator={this}
                  require
                  loaiDon={this.props.loaiDonGiaTri}
                  isValid={this.props.validate}
                  selectedValue={this.state.donViThamTraXacMinh}
                  onChange={this.handleChange.bind(this, 'donViThamTraXacMinh')}
                  name="dropdownChonDonViTTXM" />
                <ShowIf condition={this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO'}>
                  <DatePicker require
                    className="col-25"
                    value={this.state.ngayRaThongBaoTTXM}
                    label={'Ngày ra QĐ giao nhiệm vụ '+lb1}
                    name="ngayRaThongBaoTTXM"
                    endDate={new Date()}
                    onChange={this.handleChangeDate.bind(this, 'ngayRaThongBaoTTXM')}
                    bindValidator={this}
                    channel="formTaoDon" />
                </ShowIf>
                <div className="col-25">
                  <label className="pt-label">
                    <span className="val-title mb0">Thời gian báo cáo kết quả:</span>
                    <span className="val-content pt17 txt-danger">{this.state.thoiHanBaoCaoKetQuaTTXM}</span>
                  </label>
                </div>
              </ShowIf>
            </div>
          </ShowIf>
          <div className="row pr15 pl10">

            <TextArea
              require={this.state.requireText}
              label={this.state.lblTextArea}
              rows="3"
              value={this.state.noiDung ? this.state.noiDung : ''}
              onChange={this.handleChange.bind(this, 'noiDung')}
              bindValidator={this}
              channel="formTaoDon"
              name="textareaYKienCanBoXuLyDon" />
          </div>
          <div className="row pr15 pl10">
            <InPhieu inPhieu={this.props.inPhieu.bind(this)}
              huongXuLy={this.state.huongXuLy}
              loaiDonGiaTri={this.props.loaiDonGiaTri}
              trangThaiTTXM={this.state.trangThaiTTXM || null} />
          </div>
          <ShowIf condition={this.state.renderContainer}>
            <div className="container-filedinhkem mt15">
              <ContainerFileDinhKem label="Danh sách văn bản xử lý"
                bindValidator={this}
                data={this.state.listTaiLieuVanThu}
                dataShow={this.state.dataShow}
                onSave={this.props.onSave}
                loaiVanBanSuggest={this.state.loaiVanBanSuggest}
                ngayQuyetDinhSuggest={this.state.ngayQuyetDinhSuggest}
                onFileRemove={this.onFileRemove.bind(this)}
                onFileChange={this.onFileChange.bind(this)}
              />
            </div>
          </ShowIf>
        </ShowIf>
        {
          this.state.dataShow.length && this.state.nextState != 'KET_THUC' ?
            <div className="container-filedinhkem">
              <ContainerFileDinhKem label="Danh sách văn bản xử lý" disableAttachFile={true} dataShow={this.state.dataShow} />
            </div>
          :''
        }
      </div>
    );
  }
}

TruongPhongGiaoViec.defaultProps = {
  listNextStates: [],
  coQuanTiepNhanList: [],
  validate: false,
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  getState: function () {
    console.log('Need to assign getState method');
  }
}

function bindStateToProps(state) {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
    coQuanTiepNhanList: state.duLieuHeThong.coQuanTiepNhan
  }
}

export default connect(bindStateToProps)(validatable(TruongPhongGiaoViec));



// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/form-xu-ly/truong-phong/TruongPhongGiaoViec.jsx